/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import {MATERIAL_REQUEST_CARD_MODEL} from "../../../Model/Model";
import CustomCard from "../../../../../../components/CustomCard";
import {getDateFormat} from "../../../../../../Apis/functions";

const MaterialDispatchBadge = ({
                                   t,
                                   showBadge,
                                   dispatchStatusId,
                                   dispatchReason,
                                   dispatchDate,
                                   dispatchUser,
                                   showRegisteredBy = true
                               }) => {

    return (
        <>
            { showBadge &&
            (() => {
                const data = MATERIAL_REQUEST_CARD_MODEL.getById(dispatchStatusId);

                // A status the card does not declare has nothing to name, so
                // the badge is not read instead of being drawn without it
                if (!data) return null;

                return (
                    <CustomCard
                        classes={`border-radius-8px`}
                        classCard={`border-radius-8px ${data.classCard}`}
                        children={
                            <div className={`d-flex flex-column justify-content-start gap-3`}>
                                <div className={"gap-2"}>
                                    {/* The status that carries an icon is named
                                    with it on the left of its title. */}
                                    <div className={"d-flex align-items-center"}>
                                        {data?.Icon &&
                                            <div className={"mr-2 d-flex align-items-center"}>
                                                <data.Icon className={data?.infoColor}/>
                                            </div>
                                        }
                                        <p className={`ibl-font-w-600 fs-14px ${data?.fontColor}`}>
                                            {t(data?.title)}
                                        </p>
                                    </div>
                                    {dispatchReason && (
                                        <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                            {dispatchReason}
                                        </p>
                                    )}
                                </div>
                                {showRegisteredBy &&
                                    <p className={"fs-12px font-color-shades-600"}>
                                        {t(data?.byTrans)} {dispatchUser} ·{" "}
                                        {dispatchDate !== null ? getDateFormat(dispatchDate) : ""}
                                    </p>
                                }
                            </div>
                        }
                    />
                );
            })()
            }
        </>
    );
};

export default MaterialDispatchBadge;
